/* RESPONSIBLE TEAM: team-data-foundations */
import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';

export default class SuggestedQuestion extends Fragment {
  @attr('string') declare translationKey: string;
}
